import { useEffect, useRef, useState } from "react";

const stats = [
  {
    icon: "ri-award-line",
    value: "22",
    suffix: " Yıl",
    label: "Sektör Deneyimi",
    desc: "2004'ten bu yana güvenilir hizmet",
  },
  {
    icon: "ri-building-2-line",
    value: "33",
    suffix: "+",
    label: "Tamamlanan Proje",
    desc: "Türkiye genelinde başarıyla teslim edildi",
  },
  {
    icon: "ri-user-star-line",
    value: "5",
    suffix: "",
    label: "Uzman Mühendis",
    desc: "Alanında deneyimli mühendis kadrosu",
  },
  {
    icon: "ri-map-pin-2-line",
    value: "81",
    suffix: " İl",
    label: "Hizmet Alanı",
    desc: "Türkiye'nin her iline ulaşıyoruz",
  },
];

function AnimatedNumber({ target, suffix }: { target: number; suffix: string }) {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLSpanElement>(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          let start = 0;
          const duration = 1800;
          const step = Math.ceil(target / (duration / 16));
          const timer = setInterval(() => {
            start += step;
            if (start >= target) {
              setCount(target);
              clearInterval(timer);
            } else {
              setCount(start);
            }
          }, 16);
        }
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target]);

  return (
    <span ref={ref} className="tabular-nums">
      {count}
      {suffix}
    </span>
  );
}

export default function StatsSection() {
  return (
    <section className="bg-[#F8F9FA] py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A2B4A] mb-3">
            Rakamlarla Güvenli Dizayn
          </h2>
          <div className="w-14 h-0.5 bg-[#4CAF50] mx-auto" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-white rounded-2xl p-8 flex flex-col items-center text-center hover:shadow-md transition-shadow duration-300 group"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#4CAF50]/10 mb-5 group-hover:bg-[#4CAF50]/20 transition-colors duration-300">
                <i className={`${stat.icon} text-2xl text-[#4CAF50]`} />
              </div>
              <div className="text-4xl font-bold text-[#1A2B4A] mb-1">
                <AnimatedNumber target={parseInt(stat.value)} suffix={stat.suffix} />
              </div>
              <div className="text-base font-semibold text-[#2D3748] mb-1">{stat.label}</div>
              <div className="text-sm text-[#718096]">{stat.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
